import styled from 'styled-components';

export default styled.div`
  background: ${props => props.theme.bg};
  display: flex;
  font-family: ${props => props.theme.font.primary};
  justify-content: center;
  min-height: 100vh;
  width: 100vw;
`;
